import { isEmpty } from 'lodash'

const dishTypeImageFormInitialValues = values => ({
  id: values.id,
  image: isEmpty(values.imageUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.imageUrl }],
  processedImage: isEmpty(values.processedImageUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.processedImageUrl }],
  icon: isEmpty(values.iconUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.iconUrl }],
})

export default dishTypeImageFormInitialValues
